import { FunctionComponent } from "react";
import { Step } from "@App/Components/Stepper/Step";
import { useTranslation } from "react-i18next";
import { ChildStepProps } from "@App/Components/molecules/whitelabel/home/stepDefinitions/ChildStepProps";
import { VehicleReturnContractStep } from "@App/Pages/Partner/Partials/VehicleReturnContractStep";

type VehicleReturnContractStepDefinitionProps = {
  contractNumber: string | null;
  numberPlate: string | null;
  setContractNumber: (value: string) => void;
  setNumberPlate: (value: string) => void;
  stepGoBackLinkTitle: string;
  onSubmit: () => void;
} & ChildStepProps;

export const VehicleReturnContractStepDefinition: FunctionComponent<
  VehicleReturnContractStepDefinitionProps
> = ({
  contractNumber,
  numberPlate,
  setContractNumber,
  setNumberPlate,
  onSubmit,
  stepGoBackLinkTitle,
  ...stepProps
}: VehicleReturnContractStepDefinitionProps) => {
  const { t } = useTranslation();
  return (
    <Step
      {...stepProps}
      title={t("home.steps.contractData.title")}
      subtitle={null}
      completedTitle={`${t("home.steps.contractData.title")}: `}
      completedGoBackLinkTitle={stepGoBackLinkTitle}
    >
      <VehicleReturnContractStep
        contractNumber={contractNumber}
        numberPlate={numberPlate}
        setContractNumber={setContractNumber}
        setNumberPlate={setNumberPlate}
        onSubmit={onSubmit}
      />
    </Step>
  );
};
